

const Constants = {
    anonymousUser : 'anonymous',
    cricrushSponsor : 'cricrush',
    lbType : {
        WEEKLY : 'WEEKLY',
        MONTHLY : 'MONTHLY',
        LIFETIME : 'LIFETIME',
        DAILY : 'DAILY'
    },
    lbSubType : {
        WIN_LOST_RATIO : 'WIN_LOST_RATIO',
        NO_OF_COINS_EARNED : 'NO_OF_COINS_EARNED',
        NO_OF_ENTRIES_PLAYED : 'NO_OF_ENTRIES_PLAYED'
    },
    lbStatus : {
        ACTIVE : 'ACTIVE',
        COMPLETED:'COMPLETED',
        ARCHIVED:'ARCHIVED'
    },
    rewardStatus : {
        CREATED:'CREATED',
        CLAIMED : 'CLAIMED',
        PROCESSED:'PROCESSED'
    },
    matchStatus : {
        NOT_STARTED : 'NOT_STARTED',
        STARTED : 'STARTED',
        COMPLETED : 'COMPLETED',
    },
    leagueStatus : {
        NOT_STARTED : 'NOT_STARTED',
        LIVE : 'LIVE',
        COMPLETED : 'COMPLETED',
        REFUNDED : 'REFUNDED',
        REFUNDED_NO_ENOUGH_PLAYERS : 'REFUNDED_NO_ENOUGH_PLAYERS',
        ALL_COMPLETED : 'ALL_COMPLETED',
        isCompleted:(status)=>{
            return status==Constants.leagueStatus.COMPLETED||status==Constants.leagueStatus.REFUNDED||status==Constants.leagueStatus.REFUNDED_NO_ENOUGH_PLAYERS||status==Constants.leagueStatus.ALL_COMPLETED
        }
    },
    entryStatus : {
        NOT_STARTED : 'NOT_STARTED',
        LIVE : 'LIVE',
        COMPLETED : 'COMPLETED',
        REFUNDED : 'REFUNDED_ABANDONED',
        REFUNDED_NO_ENOUGH_PLAYERS : 'REFUNDED_NO_ENOUGH_PLAYERS',
        REFUNDED_ABANDONED : 'REFUNDED_ABANDONED',
        ALL_COMPLETED : 'ALL_COMPLETED',
        isCompleted:(status)=>{
            return status==Constants.entryStatus.COMPLETED||status==Constants.entryStatus.REFUNDED||status==Constants.entryStatus.REFUNDED_NO_ENOUGH_PLAYERS||status==Constants.entryStatus.ALL_COMPLETED
        }
    },
    leagueType : {
        DOUBLE : 'DOUBLE',
        QUADRUPLE : 'QUADRUPLE',
        QUINTUPLE : 'QUINTUPLE',
        TRIPLE : 'TRIPLE',
    },
    leagueCategory : {
        DREAMTEAM : 'DREAMTEAM',
        LIVE_PREDICTION : 'LIVE_PREDICTION',
        PREDICTION : 'PREDICTION',
        QUICK_PREDICTION : 'QUICK_PREDICTION',
    },
    admins : ["ramoshan@gmail.com", "rharishan@gmail.com", ""],
    reqStatus : {
        SUC:'SUCCESS',
        PEN:'PENDING',
        COM:'COMPLETED',
        FAI:'FAILED'
    },
    modals : {
        ADD_COINS:'ADD_COINS',
        CHATS:'CHATS',
        DREAMTEAM_ENTRY_CREATION:'DREAMTEAM_ENTRY_CREATION',
        ENTRIES:'ENTRIES',
        MORE:'MORE',
        NOTIFICATIONS:'NOTIFICATIONS',
        PREDICTION_ENTRY_CREATION:'PREDICTION_ENTRY_CREATION',
        RE_AUTH:'RE_AUTH',
        SIGN_IN:'SIGN_IN',
        SINGLE_LEAGUE:'SINGLE_LEAGUE',
        SPONSOR_DETAILS:'SPONSOR_DETAILS',
        TRANSACTIONS:'TRANSACTIONS',
        INFO:'INFO',
    },
    cacheKeys : {
        LINK_PARAMS : 'LINK_PARAMS'
    }
};

export {Constants}


// WEBPACK FOOTER //
// ./src/app/config/Constants.js